<template>
  <div id="index">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
          ref="formselect"
          :model="formselect"
          label-width="100px"
          class="queryform_div"
        >
          <el-row :gutter="24">
            <!-- <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('RunningTIme.FileName')">
                <el-input
                  style="width: 100%"
                  v-model="formselect.queryString"
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :md="12" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.Datefrom')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="daterange"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
              <el-button type="primary" @click="getDatas('search')" size="small">
                {{$t("button.query")}}
              </el-button>
              <el-button @click="formselect.times = []" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <div class="tableDiv">
            <el-table
              :data="tableData1"
              stripe
              style="width: 100%"
              :empty-text="$t('desc.noData')"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60px"
                fixed="left"
              >
              </el-table-column>
              <el-table-column
                prop="startDate"
                :label="$t('el.datepicker.startTime')"
                min-width="120px"
              >
              <template slot-scope="scope">
                {{scope.row.startDate | dateFormat}}
              </template>
              </el-table-column>
              <el-table-column
                prop="endDate"
                :label="$t('el.datepicker.endTime')"
                min-width="120px"
              >
              <template slot-scope="scope">
                {{scope.row.endDate | dateFormat}}
              </template>
              </el-table-column>
              <!-- <el-table-column
                prop="monthCycle"
                :label="$t('RunningTIme.LastModify')"
                min-width="100px"
              >
              </el-table-column> -->
              <el-table-column
                prop="count"
                :label="$t('desc.unboundCount')"
                min-width="40px"
              >
              </el-table-column>
              <el-table-column 
              :label="$t('title.operate')"
              width="90px">
                <template slot-scope="scope">
                  <el-button
                    type="default"
                    icon="el-icon-download"
                    circle
                    size="mini"
                    :title="$t('RunningTIme.Download')"
                    v-show="hasDownLoadAuth"
                    @click="exportUnboundDetail(scope.row)"
                  >
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev, pager, next,sizes"
              :total="pagination.totalPage"
              :current-page.sync="pagination.current"
              :page-size="pagination.pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              style="text-align: center; margin-top: 10px"
            ></el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>

  </div>
</template>

<script>
import {
  authOperationCheck,
  getUnbindStatList,
  getUnbindStatDetailList,
  exportExcelNew
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "Index",

  mounted() {
    this.getDatas();
  },

  data() {
    return {
      hasDownLoadAuth: false,
      tableData1: [],
      formselect: {},
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
    };
  },
  created: function () {
    this.authOperation("Unbound");
  },
  methods: {
    async authOperation(curPage) {
      var that = this;
      var res = await authOperationCheck(curPage);
      that.hasDownLoadAuth = res.hasDownLoadAuth;
    },
    async getDatas(type = "normal"){
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        DateTimes: that.formselect.times?that.formselect.times:new Array(),
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      let res = await getUnbindStatList(postData);
      let data = res.result.items;
      that.pagination.totalPage = res.result.totalCount;
      that.tableData1 = data;
    },
    exportUnboundDetail(row) {
      this.loading = true;
      let that = this;
      var exportData = [
        [
          that.$t("desc.airCompressorSN"),
          that.$t("desc.gatewaySN"),
          that.$t("title.controllCcn"),
          that.$t("title.ccnVersion"),
          that.$t("title.unbindDate"),
          that.$t("desc.operateUser"),
          that.$t("title.brand"),
        ],
      ];
      var fileName = that.$t("exportContent.解绑详细列表") + ".xlsx";
      getUnbindStatDetailList(row.id).then((res) => {
        if (res.result) {
          var data = res.result;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.dsn,
              item.gsn,
              item.ccn,
              item.ccnVersion,
              item.unbindDate.replace('T',' '),
              item.unbindUserName,
              item.brandCode,
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
          // exportExcel(headers, dataSource, fileName);
          this.loading = false;
        }
      });
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDatas();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDatas();
    },
  },

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #828393;
  padding-left: 10px;
}

#formPer > div {
  margin-bottom: 0px;
  border-bottom: 1px solid #828393;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
#formPer .el-form-item {
  margin-bottom: 5px;
  margin-top: 5px;
}
#formPer .el-checkbox-group {
  line-height: 16px;
  margin-top: 6px;
}
#formPer .el-checkbox {
  min-width: 80px;
}
</style>
